// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-item p[data-v-3c00ff29]{font-size:14px;font-weight:400;color:#141c20}", ""]);
// Exports
module.exports = exports;
